import React, { useState, useEffect } from 'react';
import Icon from '../../../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import { useUnreadThreads } from '../../../Data/Messages';

const Inbox = () => {
    const {unread} = useUnreadThreads();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        setUnreadCount(unread?.length ?? 0);
    }, [unread]);

    return <Link to="/messages" className="contents">
        <Icon icon="Message"
            size="2x"
            badge={unreadCount ? true : null}
        />
    </Link>;
};

export default Inbox;
